import { Component, OnInit, ViewEncapsulation, NgZone, ElementRef, HostListener } from '@angular/core';
import { FindComponent } from '../find/find.component'
import { Router } from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { BigNumber } from "ethers";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { switchMap, takeWhile, timer } from 'rxjs';
import { ONRAMPER_QUERY_PARAM, convertJSONToQueryParam } from 'app/common/components/onramper/onramper.config';
import { UserService } from 'app/services/user/user.service';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { ContractsService } from 'app/services/contract/contracts.service';
import { eContracts } from 'app/services/contract/contract.config';
import { Web3Service } from 'app/services/web3/web3.service';
import { SimpleStorageService } from 'app/services/storage/simple-storage.service';
import { environment } from 'environments/environment';

declare const Simplex;
declare const analytics;

@Component({
    selector: 'app-balancefill',
    templateUrl: './balancefill.component.html',
    styleUrls: ['./balancefill.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BalancefillComponent implements OnInit {

    public foundKryptomon
    public purchaseBoxes: any = [];
    public parsedBoxes
    public boxSelected = [false, false, false]
    // public account
    public amountSelected
    public showWidget
    public isLoading
    public kmonBalanceInit
    public bnbBalanceInit
    public waitingForFunds
    public fundsArrived
    public simulateSuccess
    public kmonAmountSelected
    public hasAllowanceBNBKMON
    public hasAllowanceNFT
    public hasAllowanceItems
    public purchaseCompleted
    public selectedBox
    public unfreezeSelected
    public successTxKryptomon
    public successTxLootbox
    public loadingTxKryptomon
    public loadingTxLootbox
    public loadingTxUnfreeze
    public successTxUnfreeze
    public loadingSwap
    public successTxSwap
    public priceUsd
    public hasFunds
    public isRefill
    public isLonger
    public amountSelectedBasket
    public totalAmount
    public amountTotal
    public hasFundsBNB
    public hasFundsKMON
    showOnramper: boolean = false;
    onramperQueryParam: { [key: string]: string } = ONRAMPER_QUERY_PARAM();
    onramperQUeryParamString: string;
    srcOnramper: SafeResourceUrl;
    partnerContext: string;
    indexCard: number;
    wallet: string;
    web3: any;
    // bnbAmountToConvert: number;

    constructor(
        private ngzone: NgZone,
        private findComponent: FindComponent,
        private router: Router,
        private simpleStorageService: SimpleStorageService,
        private http: HttpClient,
        private sanitizer: DomSanitizer,
        private eRef: ElementRef,
        private userService: UserService,
        private toastService: ToastService,
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {

        this.simulateSuccess = false;
        this.successTxKryptomon = false;
        this.loadingTxKryptomon = false;
        this.successTxLootbox = false;
        this.loadingTxLootbox = false;
        this.parsedBoxes = false;
        this.showWidget = false;
        this.isLoading = false;
        this.waitingForFunds = false;
        this.fundsArrived = false;
        this.hasAllowanceBNBKMON = false;
        this.hasAllowanceNFT = false;
        this.hasAllowanceItems = false;
        this.purchaseCompleted = false;
        this.loadingTxUnfreeze = false;
        this.successTxUnfreeze = false;
        this.loadingSwap = false;
        this.successTxSwap = false;
        this.hasFunds = false;
        this.isRefill = false;
        this.isLonger = false;
        this.amountSelected = 0;
        this.amountSelectedBasket = 0;
        this.amountTotal
        // if (this.appComponent.accounts == undefined) {
        //     this.appComponent.accountsObservable.subscribe((item: any) => {
        //         this.account = item[0];
        //         this.getKmonBalance().then(() => {
        //             this.checkStatus();
        //         })
        //         this.getBnbBalance()
        //         //this.checkStatus();
        //         this.checkPendingTx()

        //     });
        // } else {
        //     this.account = this.appComponent.accounts[0];
        //     this.getKmonBalance().then(() => {
        //         this.checkStatus();
        //     })
        //     this.getBnbBalance()
        //     this.checkPendingTx()
        //     //this.convertBNBtoKMON();
        // }
        this.web3 = this.web3Service.getWeb3();
        this.wallet = this.userService._userInfoData.recordedWallet;
        this.getKmonBalance().then(() => {
            this.checkStatus();
        })
        this.getBnbBalance()
        //this.checkStatus();
        this.checkPendingTx()

    }

    checkPendingTx() {
        let post = { walletId: this.wallet };
        this.http.post(environment.apiBaseUrl + "simplex/getPendingTx.php", post).subscribe((item: any) => {
            console.log(item)
            if (item.status) {
                this.isLonger = true;
            } else {
                this.isLonger = false;
            }
        })
    }

    checkStatus() {
        if (this.simpleStorageService.getSimple('foundKryptomon') !== undefined) {
            this.foundKryptomon = this.simpleStorageService.getSimple('foundKryptomon');
            this.selectedBox = this.simpleStorageService.getSimple('selectedBox');
            this.unfreezeSelected = this.simpleStorageService.getSimple('unfreezeSelected');
            console.log(this.foundKryptomon)
        } else {
            if (this.simpleStorageService.getSimple('selectedBox') !== undefined || this.simpleStorageService.getSimple('unfreezeSelected') !== undefined) {
                this.selectedBox = this.simpleStorageService.getSimple('selectedBox')
                this.unfreezeSelected = this.simpleStorageService.getSimple('unfreezeSelected')
                console.log('qua')
            } else {
                this.router.navigate(['/onboarding/find'])
            }
        }

        var priceUsd = 0;

        if (this.foundKryptomon) {
            priceUsd = this.foundKryptomon.order.priceUSD;
        }

        if (this.selectedBox) {
            priceUsd = priceUsd + this.selectedBox.formattedPriceUSD
        }
        if (this.unfreezeSelected) {
            priceUsd = + priceUsd + this.unfreezeSelected.formattedPriceUSD
        }

        this.priceUsd = priceUsd;
        this.amountSelectedBasket = priceUsd;
        this.amountTotal = (Math.round((this.amountSelectedBasket + this.amountSelected) * 100) / 100).toLocaleString()
        if (priceUsd <= 10) {
            var closestDecimal = (Math.ceil(10 / 10) * 10) + 5;
        } else {
            var closestDecimal = priceUsd + 5;
        }

        this.http.get("https://api.coingecko.com/api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
            console.log(item);
            let kmonPrice = item.kryptomon.usd;
            let bnbAmount = 5 / item.wbnb.usd;
            this.createBuyingBoxesRefill(kmonPrice, bnbAmount, priceUsd, item.wbnb.usd)
        })
    }


    ngOnInit(): void {
    }

    createBuyingBoxes(closestDecimal, kmonPrice, bnbAmount) {

        for (let i = 0; i < 3; i++) {
            let purchaseBox: any = {}
            purchaseBox.img = "./assets/img/Icon/coins_" + i + ".png";
            purchaseBox.totalValue = Math.round((closestDecimal + (i * 10)) * 100) / 100;
            console.log(purchaseBox.totalValue)
            purchaseBox.kmonAmount = (Math.round((purchaseBox.totalValue - 5) / kmonPrice * 100) / 100)
            purchaseBox.bnbAmount = (Math.round(bnbAmount * 100) / 100)
            if (purchaseBox.kmonAmount >= 1000) {
                purchaseBox.kmonAmountFormatted = (Math.round(purchaseBox.kmonAmount / 1000 * 100) / 100).toLocaleString() + "K"
            } else {
                purchaseBox.kmonAmountFormatted = (Math.round(purchaseBox.kmonAmount * 100) / 100).toLocaleString()
            }

            this.purchaseBoxes.push(purchaseBox);
        }
        this.parsedBoxes = true;
        this.amountSelected = this.purchaseBoxes[0].totalValue
        console.log(this.purchaseBoxes)
    }

    createBuyingBoxesRefill(kmonPrice, bnbAmount, priceUsd, bnbPrice) {

        for (let i = 0; i < 3; i++) {
            let purchaseBox: any = {}
            purchaseBox.img = "./assets/img/Icon/coins_" + i + ".png";
            purchaseBox.totalValue = Math.round((19.99 + (i * 20)) * 100) / 100;
            console.log(purchaseBox.totalValue)
            purchaseBox.kmonAmount = (Math.round((purchaseBox.totalValue - 5) / kmonPrice * 100) / 100)
            purchaseBox.bnbAmount = (Math.round(bnbAmount * 100) / 100)
            if (purchaseBox.kmonAmount >= 1000) {
                purchaseBox.kmonAmountFormatted = (Math.round(purchaseBox.kmonAmount / 1000 * 100) / 100).toLocaleString() + "K"
            } else {
                purchaseBox.kmonAmountFormatted = (Math.round(purchaseBox.kmonAmount * 100) / 100).toLocaleString()
            }

            this.purchaseBoxes.push(purchaseBox);
        }
        this.boxSelected[0] = false;
        this.parsedBoxes = true;
        console.log(this.bnbBalanceInit)
        console.log(Math.round((priceUsd) / bnbPrice * 100 * 1.10) / 100)
        if (this.kmonBalanceInit > (Math.round((priceUsd) / kmonPrice * 100) / 100)) {
            this.hasFunds = true;
            this.hasFundsBNB = false;
            this.hasFundsKMON = true;
        } else if (this.bnbBalanceInit > (Math.round((priceUsd) / bnbPrice * 100 * 1.10) / 100)) {
            this.hasFunds = true;
            this.hasFundsBNB = true;
            this.hasFundsKMON = false;
        }

        //this.amountSelected = this.purchaseBoxes[0].totalValue
        console.log(this.purchaseBoxes)
    }

    selectBox(index) {
        console.log(this.hasFunds)
        analytics.track('clicked button', { section: 'onboarding', value: 'bag of gold', step: 'step 3' });

        if (this.boxSelected[index]) {
            this.boxSelected[index] = false;
            this.amountSelected = 0;
            analytics.track('unselected bag of gold', { section: 'onboarding', value: this.amountSelected, step: 'step 2' });
        } else if (!this.boxSelected[index]) {
            this.boxSelected[index] = true;
            this.amountSelected = this.purchaseBoxes[index].totalValue
            this.kmonAmountSelected = this.purchaseBoxes[index].kmonAmount

            analytics.track('selected bag of gold', { section: 'onboarding', value: this.amountSelected, step: 'step 2' });
        }

        for (let i = 0; i < 3; i++) {
            if (i !== index) {
                this.boxSelected[i] = false;
            }
        }

        if (this.hasFunds && this.boxSelected.includes(true)) {
            this.isRefill = true;
        } else {
            this.isRefill = false;
        }
        this.amountTotal = (Math.round((this.amountSelectedBasket + this.amountSelected) * 100) / 100).toLocaleString()
    }

    purchaseRouter() {
        analytics.track('clicked button', { section: 'onboarding', value: 'purchase', step: 'step 3' });
        this.http.get("https://api.coingecko.com/api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
            console.log(item);
            console.log(this.amountSelectedBasket)
            console.log(this.amountSelected)
            console.log(this.hasFunds)
            console.log(this.isRefill)
            /*if(this.hasFunds && this.isRefill){
                this.totalAmount = (this.amountSelected*1.05)
            }else{
                this.totalAmount = ((this.amountSelected+this.amountSelectedBasket)*1.05)
            }*/
            this.totalAmount = ((this.amountSelected + this.amountSelectedBasket) * 1.05) + 1
            console.log(this.totalAmount)
            //this.totalAmount = (parseFloat(this.amountTotal)*1.05)
            let bnbAmount = (this.totalAmount) / item.wbnb.usd;
            console.log(bnbAmount * 1.10)
            console.log(this.bnbBalanceInit)
            if ((this.bnbBalanceInit) > bnbAmount * 1.10) {
                this.loadingSwap = true;
                this.checkAllowance(bnbAmount)
                //this.startPurchase()
            } else {
                this.startPurchase()
            }

        })
    }

    startPurchase() {
        console.log(this.totalAmount)
        this.isLoading = true;
        let post = { walletId: this.wallet, amount: this.totalAmount }
        console.log(post);
        this.srcOnramper = this.getSrcOnramper();
        this.showOnramper = true;
        // this.http.post("https://api.kryptomon.co/simplex/makePurchase.php", post).subscribe((item: any) => {
        //     console.log(item)

        //     if (item.status == "done") {
        //         this.showWidget = true;
        //         const params = {
        //             payment_id: item.payload.paymentId
        //         }

        //         Simplex.load(params, (event) => {

        //             Simplex.subscribe('onlineFlowFinished', (event) => {
        //                 if (event.payload.result == "success") {
        //                     this.isLoading = false;
        //                     this.checkBnbPurchase(0)
        //                     /*setTimeout(()=>{
        //                         this.simulateSuccess = true
        //                     },10000)*/
        //                 } else {
        //                     this.isLoading = false;
        //                     console.log('ops something went wrong')
        //                     this.toastService.genericError()
        //                 }
        //             })
        //         })
        //     } else {
        //         this.isLoading = false;
        //         this.toastService.genericError()
        //     }
        // })
    }

    getSrcOnramper() {
        // this.onramperQueryParam['defaultAmount'] = '';
        this.onramperQueryParam['defaultAmount'] = this.amountSelected;
        this.onramperQueryParam['networkWallets'] = ONRAMPER_QUERY_PARAM()['networkWallets'];
        this.onramperQueryParam['networkWallets'] += this.wallet;
        this.onramperQueryParam['partnerContext'] = this.partnerContext;
        // console.log(this.onramperQueryParam);
        this.onramperQUeryParamString = convertJSONToQueryParam(this.onramperQueryParam);
        return this.sanitizer.bypassSecurityTrustResourceUrl(
            'https://buy.onramper.com/?' + this.onramperQUeryParamString
        );
    }

    startDirectPurchase() {
        analytics.track('clicked button', { section: 'onboarding', value: 'purchase', step: 'step 3' });
        this.isLoading = true;
        this.purchaseCompleted = true;
        if (this.foundKryptomon) {
            this.checkAllowanceKryptomon();
        } else if (this.selectedBox) {
            this.checkAllowanceLootbox();
        } else if (this.unfreezeSelected) {
            this.checkAllowanceUnfreeze();
        }
        this.loadingSwap = false
        //this.successTxSwap = true;
    }

    closeOnramper() {
        this.showOnramper = false;
        this.isLoading = false;
        this.checkOnramperTransactionStatus();
    }

    checkOnramperTransactionStatus() {
        const maxAttempts = 20;
        const interval = 6000; // 6 seconds
        let attempts = 0;
        this.isLoading = true;
        timer(0, interval)
            .pipe(
                takeWhile(() => attempts < maxAttempts),
                // https://api-staging-n7ni4.ondigitalocean.app/onramper/status/
                // switchMap(() => this.http.get<any>('http://localhost:5530/onramper/status/' + this.partnerContext))
                switchMap(() => this.http.get<any>('https://stingray-app-4qz4a.ondigitalocean.app/onramper/status/' + this.partnerContext))
            )
            .subscribe(
                response => {
                    if (response.status === 'completed') {
                        console.log('attempts: ' + attempts);
                        //Convert directly
                        this.convertBNBtoKMON(this.totalAmount);
                        this.isLoading = false;
                        attempts = maxAttempts;
                    } else if (response.status === 'pending') {
                        attempts++;
                        console.log(`Attempt ${attempts} - answer: ${response.status}`);
                        this.isLoading = true;
                    } else {
                        this.toastService.genericError();
                        this.isLoading = false;
                    }
                },
                error => {
                    if (error.status === 404) console.error('Transaction not executed:', error);
                    this.isLoading = false;
                }
            );
    }
    closeSimplex() {
        Simplex.unload();
        this.showWidget = false;
        this.isLoading = false;
    }

    async getKmonBalance() {
        const balance = await this.contractsService.getContract(eContracts.KMON).methods.balanceOf(this.wallet).call();
        this.kmonBalanceInit = await parseFloat(this.web3.utils.fromWei(balance))
    }

    async getBnbBalance() {
        const balanceBnb = await this.web3.eth.getBalance(this.wallet);
        this.bnbBalanceInit = await parseFloat(this.web3.utils.fromWei(balanceBnb))
    }

    async checkBnbPurchase(timer) {
        Simplex.unload();
        this.waitingForFunds = true;
        this.loadingSwap = true;
        const balanceBnb = await this.web3.eth.getBalance(this.wallet);
        let newBnbBalance = await parseFloat(this.web3.utils.fromWei(balanceBnb))
        if (newBnbBalance > this.bnbBalanceInit || this.simulateSuccess) {
            let bnbReceived = newBnbBalance - this.bnbBalanceInit;
            this.http.get("https://api.coingecko.com/api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
                if (this.boxSelected.includes(true)) {
                    var amountToConvert = bnbReceived - Math.round(5 / item.wbnb.usd * 100) / 100
                } else {
                    var amountToConvert = bnbReceived;
                }
                this.fundsArrived = true;
                this.checkAllowance(amountToConvert)
            })
        } else {
            if (timer == 60) {
                this.isLonger = true;
            } else {
                setTimeout(() => {
                    timer = timer + 1;
                    this.checkBnbPurchase(timer);
                }, 5000)
            }
        }

    }

    async convertBNBtoKMON(bnbAmount = 0.0001) {

        this.http.get("https://api.coingecko.com/api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
            let minKmonAmount = bnbAmount / item.kryptomon.bnb * 0.80;
            let bnbAmountWei = this.web3.utils.toWei(bnbAmount.toString());
            let minKmonAmountWei = this.web3.utils.toWei(minKmonAmount.toString());
            let path = ["0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", "0xc732B6586A93b6B7CF5FeD3470808Bc74998224D"]
            let expiry = Math.floor(Date.now() / 1000) + 60 * 10;
            let expireWei = this.web3.utils.toWei(expiry.toString());
            console.log(expireWei)
            this.contractsService.getContract(eContracts.PancakeV2).methods.swapExactETHForTokens(minKmonAmountWei, path, this.wallet, expireWei).send({
                ...this.contractsService.additionalParameters(),
                from: this.wallet,
                value: bnbAmountWei
            }).then((item) => {
                if (item.status) {
                    this.purchaseCompleted = true;
                    if (this.foundKryptomon) {
                        this.checkAllowanceKryptomon();
                    } else if (this.selectedBox) {
                        this.checkAllowanceLootbox();
                    } else if (this.unfreezeSelected) {
                        this.checkAllowanceUnfreeze();
                    }
                    this.loadingSwap = false
                    this.successTxSwap = true;
                } else {
                    this.isLoading = false;
                    this.loadingSwap = false
                    this.toastService.genericError()
                }
            }).catch((err) => {
                this.isLoading = false;
                this.loadingSwap = false
                this.toastService.genericError()
            })
        }, (err) => {
            this.isLoading = false;
            this.loadingSwap = false
            this.toastService.genericError()
        })

    }

    async checkAllowance(bnbReceived) {
        let allowance = await this.contractsService.getContract(eContracts.WBNB).methods.allowance(this.wallet, "0x10ED43C718714eb63d5aA57B78B54704E256024E").call();
        this.hasAllowanceBNBKMON = BigNumber.from(allowance).gt(0);
        console.log(this.hasAllowanceBNBKMON)
        if (this.hasAllowanceBNBKMON) {
            this.convertBNBtoKMON(bnbReceived)
        } else {
            this.contractsService.getContract(eContracts.WBNB).methods.approve("0x10ED43C718714eb63d5aA57B78B54704E256024E", this.web3.utils.toWei('999999999999')).send({
                ...this.contractsService.additionalParameters(),
                from: this.wallet
            }).then((result) => {
                console.log(result)
                if (result.events.Approval !== undefined) {
                    this.convertBNBtoKMON(bnbReceived)
                } else {
                    this.isLoading = false;
                    this.loadingSwap = false
                    this.toastService.genericError()
                }
            }).catch((err) => {
                this.isLoading = false;
                this.loadingSwap = false
                this.toastService.genericError()
                console.log('allowance failed')
            });;
        }
    }

    async startPurchaseKryptomon() {
        console.log(this.foundKryptomon.nft.contractAddress)
        console.log(this.foundKryptomon.nft.tokenId)
        console.log(this.foundKryptomon.order.price) // this prints 100000000000000000 which is the price got from API
        console.log(this.foundKryptomon.order.paymentToken)
        await this.contractsService.getContract(eContracts.MarketplaceProxy).methods.executeOrder(
            this.foundKryptomon.nft.contractAddress,
            this.foundKryptomon.nft.tokenId,
            this.foundKryptomon.order.price,
            this.foundKryptomon.order.paymentToken
        ).send({
            ...this.contractsService.additionalParameters(),
            from: this.wallet
        }).then((item) => {
            console.log(item)
            if (item.status) {
                this.loadingTxKryptomon = false;
                this.successTxKryptomon = true;
                analytics.track('Buy Kryptomon', {
                    price: this.foundKryptomon.order.price, // in dollars
                    Generation: this.foundKryptomon.nft.data.kryptomon.genes.generation,
                    Mainelement: this.foundKryptomon.nft.elementType,
                    Productid: this.foundKryptomon.nft.tokenId,
                    secondaryelement: this.foundKryptomon.nft.elementTypeSecond
                });
                if (this.selectedBox) {
                    this.checkAllowanceLootbox();
                } else if (this.unfreezeSelected) {
                    this.checkAllowanceUnfreeze();
                }
            } else {
                this.isLoading = false;
                this.loadingTxKryptomon = false;
                this.toastService.genericError()
            }

        }).catch((err) => {
            this.isLoading = false;
            this.toastService.genericError()
            this.loadingTxKryptomon = false;
        })
    }

    async checkAllowanceKryptomon() {
        console.log(this.wallet)
        this.loadingTxKryptomon = true;
        let allowance = await this.contractsService.getContract(eContracts.KMON).methods.allowance(this.wallet, "0x61BB68bcA6eB9DCb434A52fBCB999a353c283aFF").call();
        this.hasAllowanceNFT = BigNumber.from(allowance).gt(0);
        console.log(this.hasAllowanceNFT)
        if (this.hasAllowanceNFT) {
            this.startPurchaseKryptomon()
        } else {
            this.contractsService.getContract(eContracts.KMON).methods.approve("0x61BB68bcA6eB9DCb434A52fBCB999a353c283aFF", this.web3.utils.toWei('999999999999')).send({
                ...this.contractsService.additionalParameters(),
                from: this.wallet
            }).then((result) => {
                console.log(result)
                if (result.events.Approval !== undefined) {
                    this.startPurchaseKryptomon()
                } else {
                    this.isLoading = false;
                    this.loadingTxKryptomon = false;
                    this.toastService.genericError()
                }
            }).catch((err) => {
                this.isLoading = false;
                this.loadingTxKryptomon = false;
                console.log('allowance failed')
                this.toastService.genericError()
            });;
        }
    }

    async startPurchaseLootbox() {
        let boxId = this.selectedBox.chainName;
        let boxType = this.selectedBox.type
        let amount = "1";
        console.log(amount)
        await this.contractsService.getContract(eContracts.Lootbox).methods.buyItem(this.wallet, boxId, amount).send({
            ...this.contractsService.additionalParameters(),
            from: this.wallet
        }).then((item) => {
            console.log(item)
            if (item.status) {
                this.loadingTxLootbox = false;
                this.successTxLootbox = true;
                if (this.unfreezeSelected) {
                    this.checkAllowanceUnfreeze();
                }

            } else {
                this.isLoading = false;
                this.toastService.genericError()
                this.loadingTxLootbox = false;
            }
        }).catch((err) => {
            this.isLoading = false;
            this.toastService.genericError()
            this.loadingTxLootbox = false;
        })
    }

    async checkAllowanceLootbox() {
        console.log(this.wallet)
        this.loadingTxLootbox = true;
        let allowance = await this.contractsService.getContract(eContracts.KMON).methods.allowance(this.wallet, "0xbf2E98268c8A90eE943c6Ef8E7340F0052F26b0d").call();
        this.hasAllowanceItems = BigNumber.from(allowance).gt(0);
        console.log(this.hasAllowanceItems)
        if (this.hasAllowanceItems) {
            this.startPurchaseLootbox()
        } else {
            this.contractsService.getContract(eContracts.KMON).methods.approve("0xbf2E98268c8A90eE943c6Ef8E7340F0052F26b0d", this.web3.utils.toWei('999999999999')).send({
                ...this.contractsService.additionalParameters(),
                from: this.wallet
            }).then((result) => {
                console.log(result)
                if (result.events.Approval !== undefined) {
                    this.startPurchaseLootbox()
                } else {
                    this.isLoading = false;
                    this.loadingTxLootbox = false;
                    this.toastService.genericError()
                }
            }).catch((err) => {
                this.isLoading = false;
                this.loadingTxLootbox = false;
                console.log('allowance failed')
                this.toastService.genericError()
            });;
        }
    }


    //div

    async startPurchaseUnfreeze() {
        let boxId = this.unfreezeSelected.chainName;
        let boxType = this.unfreezeSelected.type
        let amount = "1";
        console.log(amount)
        await this.contractsService.getContract(eContracts.Lootbox).methods.buyItem(this.wallet, boxId, amount).send({
            ...this.contractsService.additionalParameters(),
            from: this.wallet
        }).then((item) => {
            console.log(item)
            if (item.status) {
                this.loadingTxUnfreeze = false;
                this.successTxUnfreeze = true;
            } else {
                this.isLoading = false;
                this.toastService.genericError()
                this.loadingTxUnfreeze = false;
            }
        }).catch((err) => {
            this.isLoading = false;
            this.toastService.genericError()
            this.loadingTxUnfreeze = false;
        })
    }

    async checkAllowanceUnfreeze() {
        console.log(this.wallet)
        this.loadingTxUnfreeze = true;
        let allowance = await this.contractsService.getContract(eContracts.KMON).methods.allowance(this.wallet, "0xbf2E98268c8A90eE943c6Ef8E7340F0052F26b0d").call();
        this.hasAllowanceItems = BigNumber.from(allowance).gt(0);
        console.log(this.hasAllowanceItems)
        if (this.hasAllowanceItems) {
            this.startPurchaseUnfreeze()
        } else {
            this.contractsService.getContract(eContracts.KMON).methods.approve("0xbf2E98268c8A90eE943c6Ef8E7340F0052F26b0d", this.web3.utils.toWei('999999999999')).send({
                ...this.contractsService.additionalParameters(),
                from: this.wallet
            }).then((result) => {
                console.log(result)
                if (result.events.Approval !== undefined) {
                    this.startPurchaseUnfreeze()
                } else {
                    this.isLoading = false;
                    console.log('allowance failed')
                    this.toastService.genericError()
                }
            }).catch((err) => {
                this.isLoading = false;
                this.loadingTxUnfreeze = false;
                console.log('allowance failed')
                this.toastService.genericError()
            });;
        }
    }

    moveToBuyNFT() {
        let steps = this.simpleStorageService.getSimple('steps');
        steps[1] = true;
        this.simpleStorageService.setSimple('steps', steps);
        this.router.navigate(['/onboarding/first-kryptomon'])
    }
    goBack() {
        analytics.track('clicked button', { section: 'onboarding', value: "back", step: 'step 3' });
        this.router.navigate(['/onboarding/first-lootbox'])
    }

    goLastStep() {
        this.simpleStorageService.setSimple('purchaseAmount', this.amountTotal)
        // this.sg['purchaseAmount'] = this.amountTotal
        if (this.simpleStorageService.getSimple('selctedBox')) {
            var lootbox = this.selectedBox.formattedName
        } else {
            var lootbox = this.successTxLootbox
        }
        this.simpleStorageService.setSimple('purchasedItems', [{ item: "lootbox", value: lootbox }, { item: "kryptomon", value: this.foundKryptomon.nft.tokenId }, { item: "unfreeze-potion", value: this.unfreezeSelected }]);
        this.router.navigate(['/onboarding/complete'])
    }

    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (this.eRef.nativeElement.contains(event.target)) {
            console.log("clicked inside");
        } else {
            console.log("clicked outside");
            if (this.showOnramper) this.closeOnramper();
        }
    }

}
